module.exports = {"TXTWCL_Deposit_Funds":{"id":"TXTWCL_Deposit_Funds","defaultMessage":"Deposit Funds","track":"Deposit Funds"}}